import useHandleInputChanges from './functions/useHandleInputChanges';
import useHandleSubmit from './functions/useHandleSubmit';

export default function useChangePassowrd() {
  const {
    newPassword,
    newPasswordConfirmation,
    handleNewPasswordChange,
    handleNewPasswordConfirmationChange,
    getErrorMessageByFieldName,
    errors,
  } = useHandleInputChanges();

  const {
    handleSubmit,
    isLoading,
  } = useHandleSubmit({
    newPassword,
  });

  const isFormValid = (errors.length === 0
    && (newPassword && newPasswordConfirmation));

  return {
    handleSubmit,
    getErrorMessageByFieldName,
    newPassword,
    handleNewPasswordChange,
    newPasswordConfirmation,
    handleNewPasswordConfirmationChange,
    isFormValid,
    isLoading,
  };
}
